import { Asset } from '@oneaudi/falcon-tools';
import {
  Content,
  ContentImage,
  HeadlessContent,
  HeadlessContentImage,
} from '../EditorContentTypes';

export const mapHeadlessContent = (content: Content | HeadlessContent): Content => {
  if (content && '__type' in content && content.__type === 'aem-headless') {
    const normalisedContent: Content = {
      themeScroll: content.fields.themeScroll,
      backdropSpeed: content.fields.backdropSpeed,
      animation: {
        images: mapContentImages(content.fields.animation_images),
        headlines: content.fields.animation_headlines,
        numberOfImages: content.fields.animation_numberOfImages,
        useEveryNthImage: content.fields.animation_useEveryNthImage,
        fallback: {
          landscape: {
            assetValue: (content.fields.animation_fallback_landscape as Asset).path,
          },
          portrait: {
            assetValue: (content.fields.animation_fallback_portrait as Asset).path,
          },
          enabled: content.fields.animation_fallback_enabled,
          alt: content.fields.animation_fallback_alt,
        },
      },
      themeWltp: content.fields.themeWltp,
      wltp: content.fields.wltp,
      additionalText: content.fields.additionalText,
    };
    return normalisedContent;
  }
  return content as Content;
};

function mapContentImages(images: HeadlessContentImage[]): ContentImage[] {
  const contentImages: ContentImage[] = [];
  images.forEach((image) => {
    contentImages.push({
      landscape: {
        assetValue: (image.fields.landscape as Asset).path,
      },
      portrait: {
        assetValue: (image.fields.portrait as Asset).path,
      },
    });
  });
  return contentImages;
}
